// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';

// --- Enforce proxy base ---
axios.defaults.baseURL = '/api';

// Keep requests on /api and strip absolute prod domain if someone pasted it
axios.interceptors.request.use((config) => {
  const ABS = /^https?:\/\/api\.getclairifi\.com/i;
  if (typeof config.url === 'string') {
    // Remove prod host if present
    config.url = config.url.replace(ABS, '');
    // Ensure all relative URLs are prefixed with /api
    if (!config.url.startsWith('http') && !config.url.startsWith('/api/')) {
      config.url = config.url.startsWith('/') ? `/api${config.url}` : `/api/${config.url}`;
    }
  }
  return config;
});



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
